export default __webpack_public_path__ + "static/media/instagram.c4fe7da7.svg";